import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import About from "./components/About";
import Footer from "./components/Footer";
// import VantaBackground from "./components/VantaBackground"; 
import FloatingDotsBackground from "./components/FloatingDotsBackground";
import './App.css';

function App() {
  return (
    <div className="relative min-h-screen text-white space-bg">
      <FloatingDotsBackground />
      {/* <VantaBackground /> */}
      <div className="relative z-10">
        <Navbar />
        <Hero />
        <About />
        <Projects />
        <Contact />
        <Footer />
      </div>
    </div>
  );
}


export default App; // ✅ MUST BE 'default'
